// Opções dos selects e catálogos auxiliares. (Listagem/detalhe vêm da API — ver fundosService.)

export interface Opt { value: string; label: string; }

// Classificação CVM (antiga "forma jurídica"). Valores a confirmar com o negócio.
export const FORMA_JURIDICA: Opt[] = [
  { value: 'FIDC', label: 'FIDC' },
  { value: 'FI', label: 'FI' },
  { value: 'FIF', label: 'FIF' },
  { value: 'FIP', label: 'FIP' },
  { value: 'FII', label: 'FII' },
];

// Master / FIC — drop list (feedback). Vazio = não se aplica.
export const MASTER_FIC: Opt[] = [
  { value: 'Master', label: 'Master' },
  { value: 'FIC', label: 'FIC' },
];

// Classificação interna ANGA — drop lists (valores a confirmar com o negócio).
export const CLASSE_ANGA_1: Opt[] = [
  { value: 'Líquido', label: 'Líquido' },
  { value: 'Estruturado', label: 'Estruturado' },
];

export const CLASSE_ANGA_2: Opt[] = [
  { value: 'Multimercado', label: 'Multimercado' },
  { value: 'Renda Fixa', label: 'Renda Fixa' },
  { value: 'FIDC', label: 'FIDC' },
  { value: 'FIP', label: 'FIP' },
];

// Classificação ANBIMA de fundos (Frame ANBIMA: Nível 1 → Nível 2 → Nível 3).
// Dropdowns em cascata: o nível 1 define as opções do nível 2, que define as do nível 3.
export const ANBIMA_TREE: Record<string, Record<string, string[]>> = {
  'RENDA FIXA': {
    'SIMPLES':                  ['RENDA FIXA SIMPLES'],
    'INDEXADO':                 ['ÍNDICES'],
    'BAIXA DURAÇÃO':            ['SOBERANO', 'GRAU DE INVESTIMENTO', 'CRÉDITO LIVRE'],
    'MÉDIA DURAÇÃO':            ['SOBERANO', 'GRAU DE INVESTIMENTO', 'CRÉDITO LIVRE'],
    'ALTA DURAÇÃO':             ['SOBERANO', 'GRAU DE INVESTIMENTO', 'CRÉDITO LIVRE'],
    'LIVRE DURAÇÃO':            ['SOBERANO', 'GRAU DE INVESTIMENTO', 'CRÉDITO LIVRE'],
    'INVESTIMENTO NO EXTERIOR': ['INVESTIMENTO EXTERIOR', 'DÍVIDA EXTERNA'],
  },
  'AÇÕES': {
    'INDEXADO':                 ['ÍNDICES'],
    'ATIVO':                    ['VALOR / CRESCIMENTO', 'DIVIDENDOS', 'SUSTENTABILIDADE / GOVERNANÇA', 'SMALL CAPS', 'ÍNDICE ATIVO', 'SETORIAIS', 'LIVRE'],
    'ESPECÍFICOS':              ['FMP-FGTS', 'FECHADOS DE AÇÕES', 'MONO AÇÕES'],
    'INVESTIMENTO NO EXTERIOR': ['INVESTIMENTO NO EXTERIOR'],
  },
  'MULTIMERCADO': {
    'ALOCAÇÃO':                 ['BALANCEADOS', 'DINÂMICOS'],
    'ESTRATÉGIA':               ['MACRO', 'TRADING', 'LONG AND SHORT NEUTRO', 'LONG AND SHORT DIRECIONAL', 'JUROS E MOEDAS', 'LIVRE', 'CAPITAL PROTEGIDO', 'ESTRATÉGIA ESPECÍFICA'],
    'INVESTIMENTO NO EXTERIOR': ['INVESTIMENTO EXTERIOR'],
  },
  'CAMBIAL': {
    'CAMBIAL':                  ['CAMBIAL'],
  },
};

const _toOpts = (arr: string[]): Opt[] => arr.map((s) => ({ value: s, label: s }));
export const anbimaN1Opts = (): Opt[] => _toOpts(Object.keys(ANBIMA_TREE));
export const anbimaN2Opts = (n1?: string): Opt[] => _toOpts(Object.keys(ANBIMA_TREE[n1 ?? ''] ?? {}));
export const anbimaN3Opts = (n1?: string, n2?: string): Opt[] => _toOpts((ANBIMA_TREE[n1 ?? ''] ?? {})[n2 ?? ''] ?? []);

export const MOEDA: Opt[] = [{ value: 'BRL', label: 'BRL (Real)' }];

export const TIPO_COTA: Opt[] = [
  { value: 'abertura', label: 'Abertura' },
  { value: 'fechamento', label: 'Fechamento' },
];

export const CONDOMINIO: Opt[] = [
  { value: 'ABERTO', label: 'Aberto' },
  { value: 'FECHADO', label: 'Fechado' },
];

export const STATUS_APLICACAO: Opt[] = [
  { value: 'ABERTO', label: 'Aberto' },
  { value: 'FECHADO', label: 'Fechado' },
  { value: 'ABERTURA', label: 'Abertura' },
];

export const BENCHMARK: Opt[] = [
  { value: 'CDI', label: 'CDI' },
  { value: 'CDI+', label: 'CDI+' },
  { value: 'IPCA+', label: 'IPCA+' },
  { value: 'IBOVESPA', label: 'IBOVESPA' },
  { value: 'n/a', label: 'n/a' },
];

export const JUROS: Opt[] = [
  { value: 'simples', label: 'Simples' },
  { value: 'compostos', label: 'Compostos' },
];

export const TIPO_CONTA: Opt[] = [
  { value: 'CETIP', label: 'CETIP' },
  { value: 'SELIC', label: 'SELIC' },
  { value: 'CORRENTE', label: 'Corrente' },
];

export const PAPEL: Opt[] = [
  { value: 'ADMINISTRADORA', label: 'Administradora' },
  { value: 'GESTORA', label: 'Gestora' },
  { value: 'CUSTODIANTE', label: 'Custodiante' },
  { value: 'ESCRITURADOR', label: 'Escriturador' },
  { value: 'AUDITOR', label: 'Auditor' },
  { value: 'DISTRIBUIDOR', label: 'Distribuidor' },
  { value: 'ORIGINADOR', label: 'Originador' },
  { value: 'CEDENTE', label: 'Cedente' },
  { value: 'ESTRUTURADOR', label: 'Estruturador' },
  { value: 'INVESTIDOR', label: 'Investidor' },
  { value: 'VOICE', label: 'Voice' },
];

// Documentos exigidos no cadastro (lista a confirmar com o negócio).
export const DOCS_OBRIGATORIOS: { tipo: string; label: string }[] = [
  { tipo: 'REGULAMENTO', label: 'Regulamento' },
  { tipo: 'CONTRATO_ADMINISTRADOR', label: 'Contrato do Administrador' },
];

// Item da listagem de fundos (GET /fundos, mapeado em fundosService.apiRowToListItem).
export interface FundoListItem {
  id: number;
  cnpj: string;            // só dígitos (14)
  razao_social: string;
  nome_fantasia: string;
  codigo_anbima: string;
  moeda: string;
  administradora: string;  // prestador com papel ADMINISTRADORA
  gestor: string;          // prestador com papel GESTORA
  classe_anbima: string;   // classificação ANBIMA (nível 1)
  classe_anga_1: string;   // classificação interna ANGA (nível 1)
  status: string;          // Ativo | Inativo (derivado de is_active)
  condominio: string;      // Aberto | Fechado
  conta_cetip: string;
  conta_selic: string;
  voice: string;
  juros: string;
  // mantidos p/ a tela de detalhe
  forma_juridica: string;  // value de FORMA_JURIDICA
  data_lancamento: string; // ISO yyyy-mm-dd
}
